import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { TiptapButton } from '../../TiptapButton';

export const AddRowAfterButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().addRowAfter().run()}
         icon={<FontAwesomeIcon icon={faArrowDown} />}
         title={_js('Add row below')}
         isDisabled={!editor.can().addRowAfter()}
      />
   );
};
